import { render, staticRenderFns } from "./addChannel.vue?vue&type=template&id=daf42926&scoped=true&"
import script from "./addChannel.vue?vue&type=script&lang=js&"
export * from "./addChannel.vue?vue&type=script&lang=js&"
import style0 from "./addChannel.vue?vue&type=style&index=0&id=daf42926&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "daf42926",
  null
  
)

export default component.exports